/**
 * local storage key and value for showTutorialComplete (true when user first complete tutorial)
 */
export const SHOW_TUTORIAL_COMPLETE_MODAL = {
  key: "showTutorialCompleteModal",
  value: "true",
};
